(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["droppd-header"]) return;
  try {
    
  document.querySelectorAll('.nav-shop').forEach((menu) => {
    const desktopQuery = window.matchMedia('(min-width: 1181px)');
    let closeTimer;
    const openMenu = () => { if (desktopQuery.matches) menu.open = true; };
    const closeMenu = () => { if (desktopQuery.matches) menu.open = false; };
    menu.addEventListener('mouseenter', () => { window.clearTimeout(closeTimer); openMenu(); });
    menu.addEventListener('mouseleave', () => { closeTimer = window.setTimeout(closeMenu, 140); });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
    });
    document.addEventListener('click', (event) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.querySelectorAll('[data-droppd-locale]').forEach((select) => {
    select.addEventListener('change', () => { const form = select.closest('form'); if (form) form.submit(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droppd-main-product-v2"]) return;
  try {
    
  document.querySelectorAll('.dp-v2').forEach((section) => {
    const mainImage = section.querySelector('.dp-v2__main-image');
    const media = section.querySelector('[data-gallery-media]');
    const thumbs = Array.from(section.querySelectorAll('.dp-v2__thumb'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));

    const showImage = (index) => {
      if (!thumbs.length || !mainImage) return;
      activeIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === activeIndex));
      const thumb = thumbs[activeIndex];
      const swap = () => {
        mainImage.src = thumb.dataset.image;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = thumb.dataset.alt || mainImage.alt;
        mainImage.classList.remove('is-fading');
      };
      if (reduceMotion) { swap(); return; }
      mainImage.classList.add('is-fading');
      window.setTimeout(swap, 160);
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i)));
    const prevBtn = section.querySelector('[data-gal-prev]');
    const nextBtn = section.querySelector('[data-gal-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => showImage(activeIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => showImage(activeIndex + 1));

    let touchStartX = null;
    if (media) {
      media.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', (e) => {
        if (touchStartX === null) return;
        const dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(dx) > 44) showImage(activeIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    const stripName = (url) => (url || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '');
    const gallerySet = new Set(thumbs.map((t) => stripName(t.dataset.image)));
    if (mainImage) gallerySet.add(stripName(mainImage.currentSrc || mainImage.src));
    section.querySelectorAll('.dp-v2__description .rte img').forEach((img) => {
      const name = stripName(img.currentSrc || img.src);
      if (name && gallerySet.has(name)) img.style.display = 'none';
    });

    const track = section.querySelector('[data-rev-track]');
    if (track) {
      const step = () => {
        const card = track.querySelector('.dp-v2__review-card');
        return card ? card.getBoundingClientRect().width + 14 : 300;
      };
      const revPrev = section.querySelector('[data-rev-prev]');
      const revNext = section.querySelector('[data-rev-next]');
      if (revPrev) revPrev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      if (revNext) revNext.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    }

    const variantsNode = section.querySelector('[data-product-variants]');
    const pricesNode = section.querySelector('[data-variant-prices]');
    const variantInput = section.querySelector('[data-variant-id]');
    const optionSelects = section.querySelectorAll('[data-option-position]');
    const submit = section.querySelector('.dp-v2__submit');
    const price = section.querySelector('[data-product-price]');
    if (!variantsNode || !variantInput || !optionSelects.length) return;
    const variants = JSON.parse(variantsNode.textContent);
    let priceMap = {};
    try { priceMap = pricesNode ? JSON.parse(pricesNode.textContent) : {}; } catch (e) { priceMap = {}; }
    const updateVariant = () => {
      const choices = Array.from(optionSelects).map((select) => select.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === choices[index]));
      if (!variant) return;
      variantInput.value = variant.id;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.dataset.labelAdd || 'Add to cart') : (submit.dataset.labelSoldout || 'Sold out');
      }
      if (price && priceMap[String(variant.id)]) price.textContent = priceMap[String(variant.id)];
    };
    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droppd-product-sizing-download"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sizing-download]').forEach((download) => {
    const productSection = download.closest('.shopify-section');
    const productForm = document.querySelector('.dp-v2__form');
    if (productForm) productForm.insertAdjacentElement('afterend', download);
    if (productSection && !productSection.contains(download) && !productSection.textContent.trim()) productSection.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach((select) => { select.addEventListener('change', () => select.form.submit()); });

  } catch(e) { console.error(e); }
})();
})();
